import { useCreateStore, useProvider } from 'mobx-store-provider';
import { nanoid } from 'nanoid';
import * as React from 'react';

import { FilterMobileStore } from './store/filter-mobile.store';
import { FilterStore, FilterStoreSnapshotIn } from './store/filter.store';

interface Options {
  syncUrl: boolean;
}

/**
 * syncUrl: Get values from URL, and when the store change -> push to URL
 * */
export const withLandingFilterStore =
  (initialValue: FilterStoreSnapshotIn, options: Options = { syncUrl: false }) =>
  (Component) =>
  (props) => {
    const { seoData } = props;
    const filterStore = useCreateStore(FilterStore, {
      uuid: nanoid(),
      basePath: seoData?.url || '',
      pageType: seoData?.type,
      ...initialValue,
      defaultValue: JSON.stringify(initialValue),
      syncUrl: options.syncUrl,
    });

    const filterMobileStore = useCreateStore(FilterMobileStore, {
      uuid: nanoid(),
      desktopFilter: filterStore,
      pageType: seoData?.type,
      ...initialValue,
      defaultValue: JSON.stringify(initialValue),
    });

    const FilterStoreProvider = useProvider(FilterStore);
    const FilterMobileStoreProvider = useProvider(FilterMobileStore);

    React.useEffect(() => {
      filterStore.setInitialized();
    }, [filterStore, filterStore.initialized]);

    return (
      <FilterStoreProvider value={filterStore}>
        <FilterMobileStoreProvider value={filterMobileStore}>
          <Component {...props} />
        </FilterMobileStoreProvider>
      </FilterStoreProvider>
    );
  };
